import { BoardViewType } from "app/types";
import React from "react";
import Kanban from "../containers/Kanban";
import List from "../containers/List";

export default function Tickets({ type }: { type: BoardViewType }) {
  return (
    <React.Fragment>
      <div className="flex-grow overflow-y-auto pr-[8px] space-y-[16px] ">
        {type === BoardViewType.KANBAN ? (
          <Kanban />
        ) : (
          //  remove this for testing only ml-[38px]
          <div className="ml-[64px] flex gap-[16px] h-[calc(100vh-160px)]  ">
            <List />
          </div>
        )}
      </div>
    </React.Fragment>
  );
}
